import PropTypes from 'prop-types';
import { Autocomplete, Checkbox } from '@mui/material';
import { Input } from '../index';

function LabMultiValueSelect({
    labs,
    selectedLabs,
    onSelectLabs,
    disabled,
    required,
    errorText,
}) {
    return (
        <Autocomplete
            multiple
            disableCloseOnSelect
            disabled={disabled}
            className="form-field"
            options={labs}
            renderInput={(props) => (
                <Input {...props} error={errorText} helperText={errorText} label={`Labs ${required ? '*' : ''}`} />
            )}
            renderOption={(props, option, { selected }) => (
                <li {...props} key={option.id}>
                    <Checkbox
                        checked={selected}
                        size="small"
                        sx={{
                            marginRight: 1,
                            color: 'black',
                            '&.Mui-checked': {
                                color: 'black',
                            },
                        }}
                    />
                    {option.name}
                </li>
            )}
            getOptionLabel={(option) => option?.name || ''}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            value={labs.filter((lab) => selectedLabs.includes(lab.id))}
            onChange={(event, newValue) => {
                onSelectLabs(newValue.map((lab) => lab.id));
            }}
        />
    );
}

LabMultiValueSelect.propTypes = {
    labs: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
    })),
    selectedLabs: PropTypes.arrayOf(PropTypes.string),
    onSelectLabs: PropTypes.func,
    disabled: PropTypes.bool,
    required: PropTypes.bool,
    errorText: PropTypes.string,
};

LabMultiValueSelect.defaultProps = {
    labs: [],
    selectedLabs: [],
    onSelectLabs: () => {},
    disabled: false,
    required: false,
    errorText: '',
};

export default LabMultiValueSelect;
